module.exports = __webpack_public_path__ + "static/media/video-case-fashion.11047d39.mp4";